import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Grid } from '@mui/joy'
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton'
import crossImg from '../../../../Assets/CommonImages/crossImg.png'
import './DesignationFormStyle.css'
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon'
import CustomAutoCompleteDropdown from '../../../../Components/custom_components/CustomAutoCompleteDropdown/CustomAutoCompleteDropdown'
import { TbFileDescription } from 'react-icons/tb'
import CustomTextArea from '../../../../Components/custom_components/CustomTextArea/CustomTextArea'
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown'
import { FaHashtag } from 'react-icons/fa'
import { statusOptions } from '../../../../utils/constants'

function DesignationForm({ handleDesignationSave, isButtonDisabled, formIntialValues, id }) {


    const formik = useFormik({
        initialValues: formIntialValues,  // Set initial values directly from props

        validationSchema: Yup.object({
            DesignationName: Yup.string().required('Designation name is required'),
            DesignationStatus: Yup.string().required('Status is required')
        }),
        enableReinitialize: true,  // Enable re-initialization of form values when props change
        onSubmit: (values) => {
            handleDesignationSave(values, id);
        }
    });

    // Reset handler
    const handleReset = () => {
        formik.setFieldValue("DesignationStatus", 1)
        formik.setFieldValue("DesignationName", "")
        formik.setFieldValue("DesignationDescription", "")

        // Reset warning messages
        formik.setTouched({
            DesignationName: false,
            DesignationStatus: false,
            DesignationDescription: false
        })
    };

    return (
        <div className='designation-form-container'>
            <Grid container spacing={2}>

                {/* LEFT SIDE */}
                <Grid item xs={12} md={6}>
                    <div className='designation-mid-form-container'>
                        <div className="label-container">
                            <span className="label">Designation Name <span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">
                            <CustomTextFieldWithIcon
                                id="DesignationName"
                                name="DesignationName"
                                placeholder="Enter designation name"
                                value={formik.values.DesignationName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.DesignationName && Boolean(formik.errors.DesignationName)}
                                helperText={formik.touched.DesignationName && formik.errors.DesignationName}
                            />
                        </div>
                    </div>
                </Grid>

                {/* RIGHT SIDE */}
                {id && <Grid item xs={12} md={6}>
                    <div className='designation-mid-form-container'>
                        <div className="label-container">
                            <span className="label">Status <span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">

                            <CustomSelectDropdown
                                name="DesignationStatus"
                                placeholder="Select Status"
                                options={statusOptions}
                                value={statusOptions?.find(option => option?.value === formik?.values?.DesignationStatus) || ""}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("DesignationStatus", selectedOption ? selectedOption.value : "");
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.DesignationStatus && Boolean(formik.errors.DesignationStatus)}
                                helperText={formik.touched.DesignationStatus && formik.errors.DesignationStatus}
                                isClearable={false} // Set to false for single-select
                                width="100%"
                            />
                        </div>
                    </div>
                </Grid>}



                <Grid item xs={12} md={6}>

                    {/* Description */}
                    <div className="label-container">
                        <span className="label">Description<span className='label_required_remark'></span></span>
                    </div>
                    <div className="custom-textfield-container">
                        <CustomTextArea
                            id="DesignationDescription"
                            name="DesignationDescription"
                            placeholder="Enter DesignationDescription"
                            value={formik.values.DesignationDescription}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            rows={5}
                            StartIcon={TbFileDescription}

                        />
                    </div>
                </Grid>
            </Grid>

            <div className='form-bottom-action-buttons-container'>
                <ActionButton onClick={handleReset} label={`Reset`}
                    btnType='outlined'
                />
                <ActionButton onClick={() => formik.handleSubmit()}
                    btnDisable={isButtonDisabled}
                    label={`Save`}
                    btnType={`primary`}
                />
            </div>

        </div>
    )
}

export default DesignationForm;
